<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/team")
          i.fa.fa-users
          span.ml-1 {{ $tc("ui.teams", 1) }}
      b-breadcrumb-item
        router-link(to="/list/team")
          i.fa.fa-users
          span.ml-1 {{ $tc("ui.teams", 2) }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="teamSearch" :placeholder="$t('message.search_by_team_name')")
                div.col-md-1.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $t("ui.id") }}
                    b-form-radio(value="team_name") {{ $tc("ui.teams", 1) }}
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getTeamList(true)"
                    variant="success"
                    size="sm"
                    ).mr-2
          div.row
            div.col-md-12.mb-1
              div.form-row
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="sortKey")
                //-       option(value="team_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="team_name") {{ $tc("ui.teams", 1) }}
                //-     b-form-select(v-model="sortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-2.mb-1
                  div.form-check.form-check-inline
                    b-form-checkbox(v-model="filter")
                      div(style="color:rgba(0, 0, 0, 0.5)") {{ $t("ui.filter") }}
                    b-form-checkbox(v-model="linked" v-if="filter")
                      div(style="color:rgba(0, 0, 0, 0.5)") {{ $t("ui.linked") }}
                    b-form-checkbox(v-model="fetched" v-if="filter")
                      div(style="color:rgba(0, 0, 0, 0.5)") {{ $t("ui.fetched") }}
          div.row
            div.col-md-2.mb-1
              b-button(v-b-modal.addTeam type="button" variant="primary" size="sm").mr-2
                i.fa.fa-plus
                span {{ $t("ui.combine.add_team") }}
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="teamTotalRow"
                :per-page="getPageSize"
                v-model="currentTeamPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                b-input(:value="teamTotalRow" readonly)
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width=100 @click="sortOrder('team_id')")
                        span {{ $t('ui.id') }}
                        i(:class="changeSortKey('team_id')")
                      th.sticky-position(width=80 @click="sortOrder('sport_type')")
                        span {{ $tc('ui.sports', 1) }}
                        i(:class="changeSortKey('sport_type')")
                      th.sticky-position(@click="sortOrder('team_name')")
                        span {{ $t("ui.name") }}
                        i(:class="changeSortKey('team_name')")
                      //- th(width=75).text-center
                      //-   span {{ $t("ui.sbo") }}
                      //- th(width=75).text-center
                      //-   span {{ $t("ui.ibc") }}
                      //- th(width=75).text-center
                      //-   span {{ $t("ui.cmd") }}
                      th.sticky-position(width=100)
                        span {{ $t("ui.sbo") }}
                      th.sticky-position(width=100)
                        span {{ $t("ui.ibc") }}
                      th.sticky-position(width=100)
                        span {{ $t("ui.prefer") }}
                      //- th(width=100)
                      //-   span {{ $t("ui.cmd") }}
                      //- th(width=200)
                      //-   span {{ $t("ui.epoch_time") }}
                      th.sticky-position(width=60)
                        span {{ $t("ui.linked") }}
                      th.text-center.sticky-position(width=40)
                        span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                      //- th.text-center.sticky-position(width=80)
                      //-   span {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="teamList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in teamList")
                      td
                        span {{ item.team_id }}
                      td
                        span {{ item.sport_type }}
                      td
                        span(v-if="item.nation_link")
                          b-link.text-secondary(@click="getTeamNation(item, $event)" :title="item.team_name") {{ item.team_name }}
                        span(v-else :title="item.team_name") {{ item.team_name }}
                      //- td.text-center
                      //-   span
                      //-     i(:class="{'fas fa-check': item.sbo_link, 'fas fa-times': !item.sbo_link  }")
                      //- td.text-center
                      //-   span
                      //-     i(:class="{'fas fa-check': item.ibc_link, 'fas fa-times': !item.ibc_link  }")
                      //- td.text-center
                      //-   span
                      //-     i(:class="{'fas fa-check': item.cmd_link, 'fas fa-times': !item.cmd_link  }")
                      td
                        span {{ item.sbo_map }}
                      td
                        span {{ item.ibc_map }}
                      td
                        b-form-select(@change="changedPreferId(item, $event, item.prefer_id)" :value="item.prefer_id" v-if="isShowPreferDDL(item)" style="height: 20.5px!important;")
                          //- option(v-for="info in getPreferList(item)" v-bind:value="info.value")
                          //-   | {{ info.text }}
                          //- option(:value="item.prefer_id" v-if="item.prefer_id == null" :selected="item.prefer_id == null") {{ item.prefer_id }}
                          option(:value="item.sbo_map" :selected="item.sbo_map == item.prefer_id") {{ item.sbo_map }}
                          option(:value="item.ibc_map" :selected="item.ibc_map == item.prefer_id") {{ item.ibc_map }}
                        span(v-else) {{ item.prefer_id }}

                      //- td
                      //-   span {{ item.cmd_map }}
                      //- td
                      //-   span {{ item.epoch_time }}
                      td
                        span {{ item.link_id }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check text-info': item.mark_fetch, 'fas fa-times text-warning': !item.mark_fetch  }")
                      //- td.actions
                      //-   span(v-if="isShowPurgeSBOBtn(item)")
                      //-     a.fa.fa-trash.text-primary(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
    teamnation(ref="teamnation" :teamNationList="teamNationList")
    addteam(@clicked="addTeam" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import teamnation from "@/components/team/teamNation.vue";
import addteam from "@/components/team/addTeam.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    teamnation,
    addteam
  },
  data: () => ({
    loading: false,
    sportType: 1,
    sportList: [],
    teamList: [],
    teamNationList: [],
    filter: false,
    linked: true,
    fetched: true,
    currentTeamPage: 1,
    teamTotalRow: 0,
    teamSearch: "",
    sortKey: "team_name",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    filterBy: "team_name"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    }
  },
  mounted: function() {
    this.getSportList();
    //this.getTeamList();
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getTeamList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    showTooltip: function(e) {
      if (e.srcElement.offsetWidth < e.srcElement.scrollWidth) {
        e.srcElement.title = e.srcElement.innerText;
      }
    },
    getTeamNation: function(item, event) {
      this.getTeamNationList(item.team_id);
      this.$refs.teamnation.$refs.teamnation.show();
    },
    getTeamNationList: function(teamId) {
      let url = config.teamNationListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.team,
        team_id: teamId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.teamNationList = response.data.tbl_team_nation_list;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getDate(epochTime) {
      return new Date(epochTime / 1000);
    },
    isShowPreferDDL(info) {
      if(info.sbo_map == info.ibc_map)
        return false;
      if(info.sbo_map && info.ibc_map)
        return true;

      return false;
    },
    isShowPurgeSBOBtn(info) {
      if(info.sbo_map && info.ibc_map)
        return true;

      return false;
    },
    getPreferList(info) {
      var list = [];

      if (info.prefer_id == null)
        list.push({ value: info.prefer_id, text: info.prefer_id });

      list.push({ value: info.sbo_map, text: info.sbo_map });

      list.push({ value: info.ibc_map, text: info.ibc_map });

      // console.log(info, list);

      return list;
    },
    changedPreferId: function(info, eventStatus, orgvalue) {
      this.$helpers
        .alert({
          title: this.$t("ui.prefer_id"),
          text: this.$t("message.change_prefer_id_confirm", { name: info.team_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPreferId(info, eventStatus);
          } else {
            info.prefer_id = orgvalue.toString();
          }
        });
    },
    confirmPreferId: function(info, value) {
      let url = config.updateTeamPreferUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.team,
        sbo_team: info.sbo_map,
        ibc_team: info.ibc_map,
        prefer_id: value
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                //info.prefer_id = value;
                this.getTeamList(false);
                this.$snotify.success(this.$t("message.success"));
                // this.$helpers.showDialog(this.$t("ui.affect_value"), this.$t("message.success"), "success");
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.team
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTeamList: function(isSearch) {
      this.teamList = [];

      let url = config.teamListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentTeamPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.team,
        sport_id: this.sportType,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentTeamPage,
        page_size: this.getPageSize
      };

      if (this.filter) {
        json.linked = this.linked;
        json.fetched = this.fetched;
      }

      if (this.filterBy == "id") {
        json.team_id = this.teamSearch;
      } else {
        json.team_name = this.teamSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                //this.teamList = [];
                this.teamList = response.data.tbl_team_list;
                this.teamTotalRow = this.teamList.length > 0 ? this.teamList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addTeam: function(teamID, sportID, providerID, teamName, manualLink, epochTime, markFetch) {
      let newTeam = {
        team_id: teamID,
        sport_id: sportID,
        sport_type: this.sportList.filter(item => {
          return item.sport_id == sportID;
        })[0].sport_type,
        manual_link: manualLink,
        team_name: teamName,
        sbo_link: providerID.toLowerCase() == 'sbo' ? true : false,
        ibc_link: providerID.toLowerCase() == 'ibc' ? true : false,
        cmd_link: providerID.toLowerCase() == 'cmd' ? true : false,
        sbo_map: providerID.toLowerCase() == 'sbo' ? teamID : null,
        ibc_map: providerID.toLowerCase() == 'ibc' ? teamID : null,
        cmd_map: providerID.toLowerCase() == 'cmd' ? teamID : null,
        epoch_time: epochTime,
        link_id: null,
        mark_fetch: markFetch
      };

      this.teamSearch = "";
      this.teamList.unshift(newTeam);
      this.$helpers.showDialog(this.$t("ui.combine.add_team"), this.$t("message.success"), "success");
    },
    onDelete(item) {
      this.purgeTeam(item);
    },
    purgeTeam: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.purge_sbo_team"),
          text: this.$t("message.purge_sbo_team_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPurgeTeam(item);
          }
        });
    },
    confirmPurgeTeam(item) {
      let url = config.purgeSBOTeamUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.team,
        team_id: item.team_id,
        sbo_id: item.sbo_map,
        ibc_id: item.ibc_map
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.getTeamList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentTeamPage = 1;
      this.getTeamList();
    },
    changedPage: function(pageNo) {
      this.currentTeamPage = pageNo;
      this.getTeamList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>